import isomorphicFetch from 'isomorphic-fetch';
import path from 'path';
import { parse, format } from 'url';
import errorLog from '../../util/errorLog';
import Base from './base';
import browser from 'detect-browser';

const urlBuilder = base => {
  const { pathname, host, protocol, auth } = parse(base);
  const baseUrl = format({ host, protocol, auth });
  return (url = '') => `${baseUrl}${path.join(pathname || '', url || '')}`;
};

export class Fetch extends Base {
  constructor(basepath, defaults = {}, options = {}) {
    super(defaults, options);
    const { fetch = isomorphicFetch } = options;
    this.basepath = basepath;
    this.buildUrl = urlBuilder(this.basepath);
    this.fetch = fetch;
  }

  static PREFIX = '@@fetch';
  static STATES = ['REQUEST', 'SUCCESS', 'FAILURE'];

  isRequest(type) {
    const [REQUEST] = this.constructor.STATES;
    return this.isState(type, REQUEST);
  }

  isSuccess(type) {
    const [, SUCCESS] = this.constructor.STATES;
    return this.isState(type, SUCCESS);
  }

  isFailure(type) {
    const [, , FAILURE] = this.constructor.STATES;
    return this.isState(type, FAILURE);
  }

  base(base = this.basepath) {
    this.buildUrl = urlBuilder(base);
    return (this.basepath = base);
  }

  buildAction(action) {
    const next = super.buildAction(action);
    next.payload.url = this.buildUrl((action.payload || {}).url);
    return next;
  }

  end(
    action,
    states,
    next,
    store // eslint-disable-line no-unused-vars
  ) {
    const [, SUCCESS] = states;
    next({ ...action, type: SUCCESS });
  }

  main(
    action,
    states,
    next,
    store // eslint-disable-line no-unused-vars
  ) {
    const [REQUEST, SUCCESS, FAILURE] = states; // eslint-disable-line no-unused-vars
    const url = this.getRequestURL(action);
    next({ ...action, type: REQUEST });
    return this.fetchWithRetry(url, action);
  }

  getRequestURL(action) {
    const { payload = {} } = action;
    const { url: urlTemp } = payload;

    let url = urlTemp;
    if (!browser || browser.name === 'ie') {
      const parsedURL = parse(urlTemp, true);
      parsedURL.query['_'] = Math.floor(Math.random() * 9999999999999) + '';
      delete parsedURL.search;
      url = format(parsedURL);
    }
    return url;
  }

  fetchWithRetry(url, action) {
    const { payload = {} } = action;
    const { options = {} } = payload;

    const self = this;
    options.credentials = 'same-origin';
    let retries = 0;
    const issueFetch = () => self.fetch(url, options);
    const handleResponse = response => {
      if (retries < self.maxRetries(action, response)) {
        const retryPromise = self
          .waitMillis(self.retryDelayMillis(action, response, ++retries))
          .then(() => issueFetch())
          .then(handleResponse);

        errorLog.warning(
          `Retrying after receiving ${response.status} from ${response.url}`
        );
        return retryPromise;
      }
      return Promise.resolve({ ...action, response });
    };

    return issueFetch().then(handleResponse);
  }

  maxRetries(
    action,
    response // eslint-disable-line no-unused-vars
  ) {
    return 0;
  }

  retryDelayMillis(action, response, retryNumber) {
    if (retryNumber < 2) {
      return 0;
    }
    return Math.min(Math.pow(2, retryNumber - 1) * 100, 2000);
  }

  waitMillis(millis) {
    return new Promise(function(resolve) {
      setTimeout(resolve, millis);
    });
  }

  error(
    action,
    states,
    next,
    store // eslint-disable-line no-unused-vars
  ) {
    const [, , FAILURE] = states;
    next({ ...action, type: FAILURE });
    return Promise.resolve(action);
  }
}

export default function fetch(prefix, basepath, defaults, options) {
  return new Fetch(basepath, defaults, { ...options, prefix });
}



// WEBPACK FOOTER //
// ./js/store/middleware/fetch.js